import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import DdcData from "../components/walletHero/ddcData";
import { trimObjectValues } from "../utils/formik/objectUtils";

interface AuthenticationState {
  ddcData: DdcData;
}

const initialState: AuthenticationState = {
  ddcData: new DdcData(),
};

// Fixme: TS Name should end with "Slice"
const AuthenticationSliceDdc = createSlice({
  initialState,
  name: "registration", // Fixme: TS same as in registrationSlice
  reducers: {
    setDdcData: (state, action: PayloadAction<Partial<DdcData>>) => {
      state.ddcData = {
        ...state.ddcData,
        ...trimObjectValues(action.payload),
      };
    },
  },
});

export const { setDdcData } = AuthenticationSliceDdc.actions;

export default AuthenticationSliceDdc.reducer;
